import type { MouseEvent } from "react";

import { TextAnchorCell, TextCell } from "@similarweb/pro-logic-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import type { AssignedTeamSummary } from "../../types/teams.types";
import { navigateOnPlainClick } from "../TeamsTable/navigateOnPlainClick";

type AssignedUsersTableTeamNamesCellProps = {
    teams: readonly AssignedTeamSummary[];
};

export const AssignedUsersTableTeamNamesCell = ({ teams }: AssignedUsersTableTeamNamesCellProps) => {
    if (teams.length === 0) {
        return <TextCell>-</TextCell>;
    }

    return (
        <Flex
            alignItems="center"
            gap="4px"
            flexWrap="wrap"
        >
            {teams.map((team, index) => (
                <Flex
                    key={team.teamId}
                    inline
                    alignItems="center"
                    gap="4px"
                >
                    <TextAnchorCell
                        href={siNavigator.createTeamDetailLink({ id: team.teamId })}
                        onClick={(event: MouseEvent<HTMLElement>) =>
                            navigateOnPlainClick(event, () => {
                                void siNavigator.goToTeamDetailPage({ id: team.teamId });
                            })
                        }
                        dataAutomation={`assigned-users-team-link-${team.teamId}`}
                    >
                        {team.name ?? ""}
                    </TextAnchorCell>
                    {index < teams.length - 1 ? (
                        <Text
                            as="span"
                            fontVariant="body2"
                        >
                            ,
                        </Text>
                    ) : null}
                </Flex>
            ))}
        </Flex>
    );
};
